import {
  ECategoryType,
  ESubcategoryType,
  IInstrument,
  IProductOrganization,
} from "../Products/IProductDetail";

export enum EPlanStatus {
  All = "All",
  Approved = "Approved",
  InProcessing = "InProcessing",
  Refused = "Refused",
  CancelRequested = "CancelRequested",
  Cancelled = "Cancelled",
}

export enum EServiceType {
  All = "All",
  true = "true",
  false = "false",
}
export enum EProductType {
  FixedQty = "FixedQty",
  MultipleQty = "MultipleQty",
  AnalystQty = "AnalystQty",
  SubAccountsQty = "SubAccountsQty",
}

export enum ERecurrencyType {
  UNIQUE = "UNIQUE",
  MONTHLY = "MONTHLY",
  QUATERLY = "QUATERLY",
  SEMI_ANNUALY = "SEMI-ANNUALY",
  ANNUAL = "ANNUAL",
  BIMONTHLY = "BIMONTHLY",
  BI_ANNUAL = "BI_ANNUAL",
}

export interface IProductMyPlans {
  id: number;
  title: string;
  term_of_contract: string;
  icon: string;
  instruments: IInstrument;
  type: string;
  short_description: string;
  category: ECategoryType;
  subcategory: ESubcategoryType;
  has_reverse_order: boolean;
  market: string;
  has_value_config: boolean;
  min_value_config: number;
  max_value_config: number;
  multiply_value_config: number;
  has_configuration_changes_quarantine: boolean;
  configuration_changes_quarantine_in_days: number;
  analyst_certificate_nr: string;
  link_course_money: string;
  link_course_app: string;
  organizations: IProductOrganization[];
  url_registration: string | null;
}
export interface IMyPlans {
  last_change_config: Date;
  id: number;
  status: EPlanStatus;
  is_accepted_term: boolean;
  accepted_term_date: string | null;
  is_machine_running: boolean;
  is_algorithm_running: boolean;
  broker_integration_id: number | null;
  broker_integration: string | null;
  machine_name: string | null;
  machine_ip: string | null;
  machine_last_state: string | null;
  value: number | null;
  brokers_available: {
    id: number;
    name: string;
    customer_trade_account: string;
    customer_friendly_account: string;
    is_allowed: boolean;
  }[];
  is_inverse_side: boolean | null;
  fixed_qty: number | null;
  qty: number | null;
  sub_accounts_qty: number | null;
  whitelabel: { name: string };
  MaxQty: number | null;
  product: IProductMyPlans;
  plan: {
    name: string;
    qty_contract: number;
    price: number;
    is_recurrency: boolean;
    recurrency_type: ERecurrencyType;
  };
  has_pending_scheduled_actions: boolean;
  seller: { name: string };
  organizations?: IProductOrganization[];
}
export interface IMyPlansForDates {
  date: string;
  user_plans: IMyPlans[];
}

export interface IResponseMyPlans {
  views: {
    total: number;
    approved: number;
    inProcessing: number;
    refused: number;
    cancelRequested: number;
    cancelled: number;
  };
  dates: IMyPlansForDates[];
}
